<template lang="pug">
  v-container.pa-0(fluid)
    v-card
      v-card-title {{ $t('bankTransactionPage.importTransaction') }}
      v-card-text
        v-container.pa-0
          v-list(v-if="importedTransactionData")
            v-list-item
              template
                v-list-item-content
                  v-row.ma-0
                    v-col(cols="6").title {{ $t('bankTransactionPage.processedCount') }}
                    v-col.text-end(cols="6")
                      span {{importedTransactionData.processedCount}}
                    v-col(cols="6").title {{ $t('bankTransactionPage.unprocessedCount') }}
                    v-col.text-end(cols="6")
                      span {{getUnprocessedCount}}
                    v-col(cols="6").title {{ $t('bankTransactionPage.duplicateCount') }}
                    v-col.text-end(cols="6")
                      span {{importedTransactionData.duplicateCount}}
      v-divider
      v-card-actions
        v-spacer
        v-btn(v-if="importedTransactionData.importedCount === importedTransactionData.processedCount && unProcessedCount" color="primary" text @click="onNextButtonClick")  {{ $t('bankTransactionPage.laterButtonLabel') }}
        v-btn(v-if="showResolveButton" color="primary" text @click="onResolveButtonClick")  {{ $t('bankTransactionPage.resolveButtonLabel') }}
        v-btn(color="primary"  @click="onCloseButtonClick")  {{ $t('bankTransactionPage.finishButtonLabel') }}

</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop,} from 'vue-property-decorator'
import BankTransactionImport from "@/model/BankTransactionImport";
import BankTransaction from "@/model/BankTransaction/BankTransaction";

@Component({
  components: {

  },
})
export default class ControlImportTransactionDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean
  @Prop({ type: Object, required: false}) readonly newTransaction!: BankTransaction
  @Prop({ type: Object, required: false}) readonly importedTransactionData!: BankTransactionImport
  private processedCount: number | null = null
  private importedCount: number | null = null
  private duplicateCount: number | null = null
  private unProcessedCount: number | null = null

  get showResolveButton (): boolean {
    if(this.importedTransactionData) {
      return this.importedTransactionData.importedCount - this.importedTransactionData.processedCount > 0
    } else {
      return false
    }
  }

  get getUnprocessedCount (): number {
    if(this.importedTransactionData){
      return this.unProcessedCount =this.importedTransactionData.importedCount - this.importedTransactionData.processedCount
    } else {
      return 0
    }
  }

  onCloseButtonClick () {
    this.$emit('close')
  }

  onResolveButtonClick () {
    this.$emit('resolve')
  }

  onNextButtonClick () {
    this.onCloseButtonClick()
  }

  mounted() {
  }
}

</script>

<style lang="stylus" scoped>

</style>
